<template>
  <Wrapper
    id="slide-section-active-frame"
    :position="slideSectionActive.position"
    v-show="!preview && renderTools && slideSectionActive.id"
    style="z-index: 7;"
    :style="cssVars"
    :class="{'top': !oversection || !isFirstIndex, 'bottom': oversection && isFirstIndex}"
  >
  <!-- <pre>{{cellActive.id}}</pre>
  <pre>{{!!cellActive.id}}</pre> -->
  <!-- <pre>{{goTo('section')}}</pre> -->
  <!-- <pre>{{slideSectionActive}}</pre> -->
    <div class="label-slide-wrapper lbl-name" v-if="sectionComponent"> 
      <div :class="{'active': slideSectionActive.index === 1}"
        @click="slideSectionActive.index !== 1 && goToSlide(0)"
        v-if="slideSectionActive.index !== 0 && slideSectionActive.index > 2 && sectionComponent.componentsID.length-1 > 4"
      >
        <span
          class="disabled"
          v-show="!components[sectionComponent.componentsID[0]].properties.isEnable"
        >
          <i class="far fa-eye-slash"></i>
        </span>
        Slide 1
      </div>
      <div
        v-if="slideSectionActive.index !== 0 && slideSectionActive.index > 3 && sectionComponent.componentsID.length-1 > 4">
        ...
      </div>
      <div  v-for="(item, index) in arrSlide.slides" 
        :key="`slide_label_${arrSlide.slidesNum[index]}`" 
        :class="{'active': arrSlide.slidesNum[index]-1 == slideSectionActive.index}"
        :id="`tab_slide_${item}`"
        @click="goToSlide(arrSlide.slidesNum[index]-1)"
      >
        <span
          class="disabled"
          v-show="!components[item].properties.isEnable"
        >
          <i class="far fa-eye-slash"></i>
        </span>
        Slide {{arrSlide.slidesNum[index]}} 
      </div>
      <div
      v-if="slideSectionActive.index < sectionComponent.componentsID.length-3 && slideSectionActive.index !== sectionComponent.componentsID.length && slideSectionActive.index+1 < sectionComponent.componentsID.length && sectionComponent.componentsID.length > 5">
        ...
      </div>
      <div 
      :class="{'active': slideSectionActive.index === sectionComponent.componentsID.length}"
      @click="slideSectionActive.index != sectionComponent.componentsID.length && goToSlide(sectionComponent.componentsID.length-1)"
      v-if="slideSectionActive.index+1 < sectionComponent.componentsID.length-2 && slideSectionActive.index+1 !== sectionComponent.componentsID.length && slideSectionActive.index+2 < sectionComponent.componentsID.length && sectionComponent.componentsID.length > 4"
      >
        <span
          class="disabled"
          v-show="!components[sectionComponent.componentsID.at(-1)].properties.isEnable"
        >
          <i class="far fa-eye-slash"></i>
        </span>
        Slide {{sectionComponent.componentsID.length}}
      </div>
      <div v-if="detectDevice == 'desktop'" @click="openModalAddSlide()">
        +
      </div>
    </div>
    <div id="section-center-tool" class="d-flex align-items-center section-center-tool" v-if="!slideContainerActive.id && !widgetActive.id && detectDevice == 'desktop'">

      <b-badge id="section-center-tool-badge"
        pill
        variant="light"
        class="d-flex align-items-center mb-10 my-2"
      >
        <div class="d-flex" style="gap: 10px;">
          <div @click="openModal" class="btn-tool">
            <div class="d-flex align-items-center cursor-pointer">
              <i class="far fa-image"></i>
              <div class="ml-5">
                <div class="fs-db-20">{{ $t('engine.floatframeTool.miniBtn.slide.btnChangeBackground', languageEngine) }}</div>
              </div>
            </div>
          </div>
          <!-- <div class="vl"></div>
          <div
            @click="openImageCrop"
            v-b-tooltip.hover
            title="Crop Image"
            class="d-flex align-items-center cursor-pointer btn-tool"
          >
            <i class="far fa-crop-alt"></i>
          </div> -->
          <div v-if="detectDevice == 'desktop'" class="vl"></div>
          <div
            v-if="detectDevice == 'desktop'"
            v-b-tooltip.hover
            :title="$t('engine.floatframeTool.btnHover.tooltip.lblLink', languageEngine)"
            class="d-flex align-items-center cursor-pointer"
            @click="addLink"
          >
            <i class="fas fa-link"></i>
          </div>
          <div v-if="currentSlideID && components[currentSlideID].properties.isEnableLink && detectDevice !== 'mobile'" class="vl"></div>
        
          <div
            v-if="currentSlideID && components[currentSlideID].properties.isEnableLink && detectDevice !== 'mobile'"
            v-b-tooltip.hover
            :title="$t('engine.floatframeTool.btnHover.tooltip.lblRemoveLink', languageEngine)"
            class="d-flex align-items-center cursor-pointer btn-tool"
            @click="unLink"
          >
            <div style="font-size: 14px">
              <i class="far fa-unlink"></i>
            </div>
          </div>
        </div>
      </b-badge>
    </div>
    <template v-if="!slideContainerActive.id && !widgetActive.id && detectDevice == 'desktop'">
      <SectionTool class="d-flex align-items-center section-tool" style="pointer-events: visible;">
        <div class="d-flex justify-content-center align-items-center btn-tool-wrapper" 
          @click.stop.prevent="duplicateSection()"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnDuplicateSection', languageEngine)"
          v-if="!isSectionPage"
        >
          <i class="icon-fa mt-1 far fa-clone"></i>
        </div>
        <div class="justify-content-center align-items-center btn-tool-wrapper d-flex" 
          v-b-tooltip.hover 
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnUpSection', languageEngine)"
          :class="{'disabled': !isShowUp}"
          :style="`pointer-events: ${!isShowUp ? 'none' : 'all'}`"
          @click.stop.prevent="isShowUp && moveSectionUp()"
        >
          <i class="icon-fa mt-1 far fa-arrow-up"></i>
        </div>
        <div class="justify-content-center align-items-center btn-tool-wrapper d-flex"
          v-b-tooltip.hover
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnDownSection', languageEngine)"
          :class="{'disabled': !isShowDown}"
          :style="`pointer-events: ${!isShowDown ? 'none' : 'all'}`"
          @click.stop.prevent="isShowDown && moveSectioDown()"
        >
          <i class="icon-fa mt-1 far fa-arrow-down" v-if="isShowDown"></i>
        </div>
        <div class="d-flex justify-content-center align-items-center btn-tool-wrapper" 
          v-b-tooltip.hover 
          :title="$t('engine.floatframeTool.floatframeActive.section.miniBtn.btnRemoveSection', languageEngine)"
          v-if="!isSectionPage"
          @click.stop.prevent="removeSection()"
        >
          <i class=" icon-fa mt-1 far fa-trash-alt"></i>
        </div>
      </SectionTool>
      <AddSection
        class="add-section top"
        style="pointer-events: none;"
        v-if="!['reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode) && !slideContainerActive.id && !widgetActive.id && detectDevice == 'desktop'"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper" style="pointer-events: auto;">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('up')">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                {{ $t('engine.floatframeTool.floatframeActive.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>  
      </AddSection>
      <AddSection
        v-if="!isSectionPage && !widgetActive.id && !['reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode) && detectDevice == 'desktop'"
        class="add-section bottom"
        style="pointer-events: none;"
      >
        <div class="center-hv w-100 d-flex justify-content-center">
          <div class="d-flex justify-content-center icon-section-wrapper" style="pointer-events: auto;">
            <div class="icon-hover-label btn-hover" @click.stop.prevent="addSection('down')">
              <span class="text-white icon-wrapper">
                <i class="fas fa-plus"></i>
              </span>
              <span class="icon-label">
                {{ $t('engine.floatframeTool.floatframeActive.section.btnAddSection', languageEngine) }}
              </span>
            </div>
          </div>
        </div>
      </AddSection>
      <div class="reheight-slide-section" ref="tool-reheight-slide" style="width: 100%;" v-if="detectDevice == 'desktop'">
        <div v-if="mode == reheight_mode" class="mx-2 label-reheight" style="">
          Section Height: {{height}}
        </div>
      </div>
    </template>
  </Wrapper>
</template>
<script>
import {
  SectionTool,
  AddSection,
  // FloatframeActive,
  Wrapper,
} from "@components/tool/FloatFrameActive.styled.js";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    SectionTool,
    AddSection,
    // FloatframeActive,
    Wrapper,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
      reheight_mode: 'reheight_component',
      height: 0,
    }
  },
  computed: {
    ...mapGetters({
      scrollPosition: "scrollPosition",
      components: "designIframe/metadata/components",
      CONTENT_CONTAINER: "designIframe/metadata/CONTENT_CONTAINER",
      preview: "designIframe/preview",
      slideSectionActive: "designIframe/frame/slideSectionActive",
      slideContainerActive: "designIframe/frame/slideContainerActive",
      widgetActive: "designIframe/frame/widgetActive",
      renderTools: "designIframe/frame/renderTools",
      mode: "designIframe/mode",
      detectDevice: "detectDevice",
      siteComponents: "designIframe/metadata/siteComponents",
      sitePageID: "designIframe/metadata/sitePageID",
      languageEngine: "designIframe/userPreference/languageEngine",
      limit: "designIframe/page/limit",
    }),
    cssVars() {
      return {
        '--floatframe-color-active': !this.slideContainerActive.id && !this.widgetActive.id ? '#12A9FF' : '#0B77B5',
        '--floatframe-border-active': !this.slideContainerActive.id && !this.widgetActive.id ? '4px solid #12A9FF' : '2px solid #0B77B5',
        '--reheight-z-index': this.mode == this.reheight_mode ? '5' : '1',
        '--reheight-hover-bg': this.mode == this.reheight_mode ? 'transparent' : 'rgba(173, 223, 252, 0.5)',
      }
    },
    sections() {
      return this.CONTENT_CONTAINER.componentsID;
    },
    indexSection() {
      return this.CONTENT_CONTAINER.componentsID.indexOf(this.slideSectionActive.id);
    },
    isSectionPage() {
      return this.slideSectionActive.id === "SECTION_PAGE";
    },
    isPageSystem() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf("SECTION_PAGE");
      return index >= 0;
    },
    isBeforeLastIndex() {
      const index = this.CONTENT_CONTAINER.componentsID.indexOf(this.slideSectionActive.id);
      return this.CONTENT_CONTAINER.componentsID.length - 2 == index;
    },
    isFirstIndex() {
      return this.indexSection == 0;
    },
    isLastIndex() {
      return (
        this.CONTENT_CONTAINER.componentsID.length - 1 == this.indexSection
      );
    },
    isShowUp() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isFirstIndex) {
          show = false;
        } else {
          show = true;
        }
      }
      return show;
    },
    isShowDown() {
      let show = true;
      if (this.isSectionPage) {
        show = false;
      } else {
        if (this.isBeforeLastIndex && this.isPageSystem) {
          show = false;
        } else {
          show = true;
          if (this.isLastIndex) {
            show = false;
          }
        }
      }
      return show;
    },
    isOverScroll() {
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    sectionComponent() {
      return this.slideSectionActive.id && this.components[this.slideSectionActive.id]
    },
    currentSlideID() {
      return (this.slideSectionActive.id && this.slideSectionActive.index >= 0) && this.sectionComponent.componentsID[this.slideSectionActive.index];
    },
    getMainPage() {
      const mainPageID =
        this.siteComponents &&
        this.siteComponents.MAIN_PAGE &&
        this.siteComponents.MAIN_PAGE.properties &&
        this.siteComponents.MAIN_PAGE.properties.pageID;
      return mainPageID;
    },
    oversection() {
      return (
        this.sitePageID == this.getMainPage && this.HEADER.style.isEnableOverSection
      );
    },
    HEADER() {
      return this.siteComponents.HEADER;
    },
    arrSlide() {
      return this.totalSlide();
    }
  },
  mounted () {
    this.dragElement();
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    dragElement() {
      if (this.slideSectionActive.id && !this.slideContainerActive.id && !this.widgetActive.id && this.detectDevice == 'desktop') {
        this.$refs["tool-reheight-slide"].onmousedown = this.dragMouseDown;
      }
    },
    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      this.$store.dispatch("design/setMode", {
        mode: this.reheight_mode,
      });
      // this.components[this.slideSectionActive.id].style.height = this.height
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
      this.elementDrag(e);
    },
    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();

      const position = document.getElementById(`comp-${this.slideSectionActive.id}`);
      this.height = position.offsetHeight;

      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
  
      this.components[this.slideSectionActive.id].style.height =
            position.offsetHeight -
            this.pos2;
      // this.components[this.slideSectionActive.id].style.height = this.components[this.slideSectionActive.id].style.height - this.pos2;
      // this.height = this.components[this.slideSectionActive.id].style.height;

      this.$nextTick(() => {
        this.$store.dispatch("designIframe/frame/reRenderFrame");
      });
    },
    closeDragElement() {
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
      this.$store.dispatch("design/setMode", {});
      document.onmouseup = null;
      document.onmousemove = null;
    },
    addSection(direction) {
      const sectionCountInPage = this.sections.length;
      if(!this.limit.section || sectionCountInPage < this.limit.section) {
        this.$store.commit("designIframe/setStatePath", {
          value: {
            sectionID: this.slideSectionActive.id,
            direction,
          },
          path: "/component/addComponent/section",
        });
        this.$store.dispatch("design/setMode", {
          mode: "add_section",
        });
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-section",
          payload: {},
        });
      }
    },
    classPositionTool() {
      const element = document.getElementById("slide-section-active-frame");
      if(element) {
        const rect = element.getBoundingClientRect();
        const topSpace = rect.top;
        const leftSpace = rect.left;
        const rightSpace =
          document.documentElement.clientWidth - (leftSpace + rect.width);
        const bottom =
          document.documentElement.clientHeight - (topSpace + rect.height);
        const toolHeight = -40;
         if (topSpace <= 0 && leftSpace <= 0 && rightSpace <= 0 && bottom <= 0) {
          this.positionTool = "overscreen";
        } else {
          this.positionTool = [
            {
              value: topSpace + toolHeight,
              class: "top"
            },
            {
              value: bottom + toolHeight,
              class: "bottom"
            },
          ].sort((a, b) => b.value - a.value)[0].class;
        }
      }
    },
    duplicateSection() {
      const sectionCountInPage = this.sections.length;
      const slideSections = Object.keys(this.components)
      .filter(key => key.includes('sec'))
      .reduce((obj, key) => {
      if (this.components[key].type === 'SLIDE_SECTION') obj[key] = this.components[key]
        return obj;
      }, {});
      const slideSectionCountInPage = Object.keys(slideSections).length;

      if(!this.limit.slideSection || slideSectionCountInPage < this.limit.slideSection) { // Check Limit Slide Section
        if(!this.limit.section || sectionCountInPage < this.limit.section) { // Check Limit Section
          this.$store.commit("designIframe/setStatePath", {
            value: {
              sectionID: this.slideSectionActive.id,
            },
            path: "/component/addComponent/section",
          });
          this.$store.dispatch("designIframe/component/duplicateSection", {
            component_id: this.slideSectionActive.id,
          });

          this.$store.dispatch("designIframe/snapshot/genSnapshot");
        } else {
          this.$store.dispatch("design/setModal", {
            name: "modal-alert-limit-section",
            payload: {},
          });
        }
      } else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-slide-section",
          payload: {},
        });
      }
    },
    moveSectionUp() {
      this.$store.dispatch("designIframe/component/moveSectionUp", {
        id: this.slideSectionActive.id,
      });
    },
    moveSectioDown() {
      this.$store.dispatch("designIframe/component/moveSectionDown", {
        id: this.slideSectionActive.id,
      });
    },
    removeSection() {
      this.$store.dispatch("designIframe/component/removeSection", {
        id: this.slideSectionActive.id,
      });
      this.$store.dispatch("designIframe/frame/setSlideSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
    },
    goToSlide(index) {
      this.$store.dispatch("designIframe/frame/setWidgetHover", {})
      this.$store.dispatch("designIframe/frame/setWidgetActive", {})
      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
      this.$store.dispatch("designIframe/frame/setResizeMarginHover", {})
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
        component_id: this.slideSectionActive.id,
        index: index
      })
    },
    openImageCrop() {
      this.$store.dispatch("designIframe/imageCrop/setImageCrop", {
        componentID: this.currentSlideID,
      });
      this.$store.dispatch("design/setMode", {
        mode: "crop_image",
      });
    },
    addLink() {
      this.$store.dispatch("design/setModal", {
        name: "modal-add-link-widget",
        payload: {
          id: this.currentSlideID,
          properties: this.components[this.currentSlideID].properties,
        },
      });
    },
    unLink() {
      this.components[this.currentSlideID].properties.isEnableLink = false;
      this.components[this.currentSlideID].properties.link = {
        type: "url",
        url: null,
        pageID: null,
        target: "_blank",
        sectionPageID: null,
        sectionID: null,
        fileID: null,
        phoneCountry: null,
        phoneFormat: null,
        phone: null,
        emailSubject: null,
        email: null,
      };
      this.$store.dispatch("designIframe/snapshot/genSnapshot");
    },
    openModal() {
      this.$store.dispatch("design/openFilemanager", {
        componentConfig: {
          id: this.currentSlideID,
          type: 'slide-page'
        },
        limit: 20,
        isShowFlaticon: false,
        isShowDocument: false,
      });
    },
    openModalAddSlide() {
      const slidePageCountInPage = this.sectionComponent.componentsID.length;
      if(!this.limit.slidePage || slidePageCountInPage < this.limit.slidePage) {
        var compID = this.slideSectionActive.id;
        this.$store.dispatch("designIframe/frame/setSlideSectionActive", {
          component_id: compID,
          index: this.slideSectionActive.index
        })
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
        this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});
        this.$store.dispatch("designIframe/frame/setCellActive", {});
        this.$store.dispatch("designIframe/frame/setCellHover", {});
        this.$store.dispatch("designIframe/frame/setWidgetActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetHover", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
        this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});

        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", compID, this.sectionComponent.componentsID[this.slideSectionActive.index]],
        });

        this.$store.dispatch("design/setModal", {
          name: "modal-add-slide",
          payload: {
            slideSectionID: this.slideSectionActive.id,
            numberSlide: this.sectionComponent.componentsID.length,
          },
        });
      }
      else {
        this.$store.dispatch("design/setModal", {
          name: "modal-alert-limit-slide-page",
          payload: {},
        });
      }
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        if(this.mode == this.reheight_mode) this.closeDragElement();
      }
    },
    totalSlide() {
      if (this.sectionComponent) {
        const totalSlides = this.sectionComponent.componentsID.length
        let startSlide, endSlide;
        if (totalSlides <= 5) {
          startSlide = 1;
          endSlide = totalSlides;
        } else {
          if (this.slideSectionActive.index + 2 <= 3) {
            startSlide = 1;
            endSlide = 5;
          } else if (this.slideSectionActive.index + 2 >= totalSlides) {
            startSlide = totalSlides - 4;
            endSlide = totalSlides;
          } else {
            startSlide = this.slideSectionActive.index - 1;
            endSlide = this.slideSectionActive.index + 3;
          }
        }
        const slidesNum = _.range(startSlide, endSlide + 1);
        const slides = slidesNum.map(i => {
          return this.sectionComponent.componentsID[i-1];
        })
        const slideConfig = {
          totalSlides: totalSlides,
          startSlide: startSlide,
          endSlide: endSlide,
          slidesNum: slidesNum,
          slides: slides
        };

        return slideConfig;
      } else {
        return null;
      }
    },
  },
  watch: {
    slideSectionActive: {
      deep: true,
      handler() {
        const element = document.getElementById("slide-section-active-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
            if (this.slideSectionActive.id && !this.slideContainerActive.id && !this.widgetActive.id && this.detectDevice == 'desktop') {
              this.$refs["tool-reheight-slide"].onmousedown = this.dragMouseDown;
            }
            this.totalSlide()
          })
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  #slide-section-active-frame {
    &::after {
      border: var(--floatframe-border-active);
    }
  }
  .icon-section-wrapper {
    position: relative;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    .icon-hover-label {
      position: relative;
      display: inline-block;
      white-space: nowrap;
      outline: none;
      transition: ease-out 0.3s;
      height: 30px;
      background: #12A9FF;
      border-radius: 20px;
      width: 100% !important;
      padding: 3px 10px;
      .icon-label {
        white-space: nowrap;
        pointer-events: none;
        color: #ffffff;
        opacity: 1;
        position: static;
        transition: ease-out 0.3s;
      }
      .icon-wrapper {
        left: 20%;
      }
    }
  }
  .btn-tool-wrapper {
    &:hover {
      .icon-fa {
        color: #24BEE2;

      }
    }
    &.disabled {
      .icon-fa {
        color: #AEB5BD
      }
    }
  }
  .label-slide-wrapper {
    display: flex;
    pointer-events: auto;
    position: absolute;
    width: max-content;
    line-height: 12px;
    bottom: 100%;
    left: 0;
    z-index: 3;  
    > div {
      padding: 2px 6px;
      background-color: #A9A9A9;
      color: #ffffff;
      font-family: 'Roboto';
      font-size: 12px;
      height: max-content;
      &:not(:first-child) {
        margin-left: 4px;
      }
      &.active {
        background-color: var(--floatframe-color-active);
      }
      &:not(.active):hover {
        background-color: #F4FCFF;
        color: #12A9FF;
        cursor: pointer;
      }
    }
  }
  .section-center-tool {
    pointer-events: all;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    justify-content: center;
    right: 0;
    font-weight: 500;
    transition: all 0.1s ease;
    line-height: 1;
    font-size: 20px;
  }

  .badge {
    bottom: 10px;
    background: #ffffff !important;
    border: 1px solid #dee3e6 !important;
    font-weight: normal;
    padding: 4px 16px;
    height: 32px;
    gap: 10px;
    position: absolute;
    box-shadow: 0px 8px 16px 0px #00000026;
  }
  .vl {
    border-left: 2px solid #dfdfdf;
  }

  .btn-tool:hover {
    svg, .fs-db-20 {
      color: #24BEE2
    }
  }

  .reheight-slide-section {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 15px;
    cursor: ns-resize;
    z-index: var(--reheight-z-index);
    pointer-events: all;
    &:hover {
      background-color: var(--reheight-hover-bg);
    }
    .label-reheight {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      color: #ffffff;
      height: 25px;
      width: fit-content;
      top: 5px;
      left: 55%;
      border-radius: 4px;
      z-index: 10;
      padding-left: 8px;
      padding-right: 8px;
    }
  }

</style>